import { useMemo } from "react";

import { deleteAction } from "b2b/components/common-grid-columns";
import * as COLUMNS_AVAILABLE from "b2b/components/projekty-grid-columns/columnsAvailable";

export default function useColumns({ handleDelete }) {
  const columns = [
    COLUMNS_AVAILABLE.nazev(),
    COLUMNS_AVAILABLE.popis(),
    COLUMNS_AVAILABLE.smlouva(),
    COLUMNS_AVAILABLE.vytvoril(),
    COLUMNS_AVAILABLE.datumVytvoreni(),
    COLUMNS_AVAILABLE.upravil(),
    COLUMNS_AVAILABLE.datumUprava(),
    deleteAction(handleDelete, ({ dataRow }) => !dataRow?.pouzito)
  ];
  return useMemo(() => [columns], [handleDelete]);
}
